module.exports = __webpack_public_path__ + "5dc7ca745da65bf7c5119be5a47789cf.pdf";